import { SiteRequestionsCardGridAreaName } from './constants';

import { InfoCard } from '../common/InfoCard';

import styled from 'styled-components';

export const StyledSiteRequestionsCard = styled(InfoCard)`
  grid-area: ${SiteRequestionsCardGridAreaName};
`;
